import React, {useEffect, useState} from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiContainer from "../../General/SteddiContainer";
import SectionHeader from "../../General/SectionHeader";
import {List, ListItemAvatar, ListItemText, Typography} from "@mui/material";
import DynamicListItem from "../../General/DynamicListItem";
import {CalendarDays, CalendarX, LineChart} from "lucide-react";
import useAppState from "../../../stores/appStateStore";
import useOrderState from "../../../stores/orderStore";
import SteddiInfoItem from "../../General/SteddiInfoItem";
import DateHelpers from "../../../helpers/DateHelpers";
import 'animate.css';
import {animateCSS} from "../../../helpers/Animation";
import PaymentFreeMonth3 from "../../General/PaymentFreeMonth3";
import Månedsbeløp from "../../Esign/InfoItems/Månedsbeløp";

export default function PaymentFreePage(){
  const state = useOrderState((state) => state)
  const appState = useAppState((state) => state)
  const [selectedAmount, setSelectedAmount] = useState(state.paymentFree?.paymentFreeMonths.length ?? 0)
  const [selectedMonths, setSelectedMonths] = useState<number[]>(state.paymentFree?.paymentFreeMonths ?? [])
  const [currentEstimate, setCurrentEstimate] = useState<number | undefined>(0)

  function handleChangeSelectedMonths(months: number[]) {
    setSelectedMonths(months)
  }

  function handleChangeSelectedAmount(amount: number) {
    setSelectedAmount(amount)
  }

  useEffect(() => {
    setSelectedMonths(state.paymentFreeMonths)
  }, [])

  useEffect(() => {
    if (state.paymentFreeMonths.length != selectedAmount) {
      appState.setGoNextDisabled(true)
      appState.setGoNextTooltip("Mangler betalingsfri måned")
    } else if(state.paymentFreeMonths.length === state.paymentFree?.paymentFreeMonths.length && state.paymentFreeMonths.every(m => state.paymentFree?.paymentFreeMonths.includes(m))) {
      appState.setGoNextDisabled(true)
      appState.setGoNextTooltip("Kan ikke være de samme månedene som fra før")
    } else {
      appState.setGoNextDisabled(false)
    }
  }, [state.paymentFreeMonths, selectedAmount])

  useEffect(() => {
    state.setPaymentFreeMonths(selectedMonths)
  }, [selectedMonths])


  useEffect(() => {
    animateCSS(".shakeMe", "headShake")

    switch(selectedAmount){
      case 0:
        setCurrentEstimate(state.paymentFree?.estimates.none)
        break
      case 1:
        setCurrentEstimate(state.paymentFree?.estimates.single)
        break
      case 2:
        setCurrentEstimate(state.paymentFree?.estimates.double)
        break
    }
  }, [selectedAmount]);

  function getPrevPaymentFreeText() {
    if(!state.paymentFree?.paymentFreeMonths?.length)
      return "Ingen"
    return state.paymentFree!.paymentFreeMonths.map(m => DateHelpers.getMonthFromId(m - 1)).join(" og ")
  }

  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <SectionHeader>Er det noen måneder du vil velge bort?</SectionHeader>
      </Grid2>
      <Grid2 xs={12}>
        <Typography>Du kan velge inntil to betalingsfrie måneder i året, hvis du vil. Vær oppmerksom på at du får et høyere månedsbeløp resten av månedene hvis du velger dette.</Typography>
      </Grid2>
      <Grid2>
        <Typography>I en betalingsfri måned får du en faktura som viser strøm- og nettleiekostnadene du har hatt hos strømleverandøren din. Disse kostnadene registreres på saldoen – men det blir ingen betaling til forfall den måneden.</Typography>
      </Grid2>
      <Grid2 xs={12}>
        <SectionHeader>Ditt tidligere valg</SectionHeader>
      </Grid2>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding={"sm"}>
          <SteddiInfoItem title={"Betalingsfri måned"} subtitle={getPrevPaymentFreeText()} icon={<CalendarDays/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding={"sm"}>
          <Månedsbeløp override={state.paymentFree?.currentPrice} noShake/>
        </SteddiContainer>
      </Grid2>

      <PaymentFreeMonth3 selectedMonths={selectedMonths} setSelectedMonths={handleChangeSelectedMonths} selectedAmount={selectedAmount} setSelectedAmount={handleChangeSelectedAmount} existingCustomer={true} hasExistingMonths={state.paymentFree!.paymentFreeMonths.length > 0} prices={state.paymentFree?.estimates} title={"Endre eller avbestill betalingsfri måned"}/>

      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding={"sm"}>
          <Månedsbeløp override={currentEstimate}/>
        </SteddiContainer>
      </Grid2>
      <Grid2 xs={12} sm={6}>
        <SteddiContainer padding={"sm"}>
          <SteddiInfoItem title={"Første forfallsdato"} subtitle={DateHelpers.toDateString(DateHelpers.nextInvoiceDate())} icon={<CalendarDays/>} bgColor={"secondary"}/>
        </SteddiContainer>
      </Grid2>
    </Grid2>
  )
}